<template>
  <div class="container">
    <!--Search section-->
    <div class="columns is-centered">
      <!--izmjenio Koča "search" unutar polja (uklonjen is-gapless)-->
      <!--Search item-->
      <div class="column is-9">
        <div class="grid-container">
          <!--Search input field-->
          <div class="grid-item-search">
            <input
              class="g-input"
              style="padding: 14px"
              ref="searchInput"
              type="text"
              v-model="rawString"
              @keyup.enter="commitSearchString"
              :placeholder="searchPlaceholder"
            />
          </div>
          <div class="grid-item-search-x">
            <!-- Strict search button tag -->
            <button class="g-search-x" @click="clearSearchInput">
              <i class="g-search-x fa fa-times"></i>
            </button>
          </div>
          <div class="grid-item-search-strict">
            <!-- Strict search button tag -->
            <button class="g-search-x" @click="toggleStrictSearch">
              <i class="g-search-x fa fa-crosshairs"></i>
            </button>
          </div>
          <!-- Category selector treeview -->
          <div class="grid-item-category">
            <treeselect
              class="my-categories"
              style="padding: 14px"
              name="categories"
              :placeholder="categoryPlaceholder"
              :multiple="false"
              :clearable="true"
              :searchable="true"
              :disabled="false"
              :open-on-click="true"
              :open-on-focus="true"
              :clear-on-select="true"
              :close-on-select="true"
              :always-open="false"
              :append-to-body="false"
              :options="categories"
              :limit="3"
              :max-height="400"
              :value="selectedCategoryId"
              @input="setSelectedCategoryId"
            />
          </div>
          <!--Filter by manufacturer-->
          <div class="grid-item-manufacturer">
            <treeselect
              name="manufacturers"
              :placeholder="manufacturerPlaceholder"
              :multiple="true"
              :searchable="true"
              :disabled="false"
              :open-on-click="true"
              :open-on-focus="true"
              :clear-on-select="true"
              :close-on-select="true"
              :always-open="false"
              :append-to-body="false"
              :options="manufacturers"
              :limit="3"
              :max-height="400"
              :value="filteredManufacturerIds"
              @input="updateFilteredManufacturerIds"
              @close="filterClosed"
            />
          </div>
          <!--Filter by supplier-->
          <div class="grid-item-supplier">
            <treeselect
              name="suppliers"
              :placeholder="supplierPlaceholder"
              :multiple="true"
              :searchable="true"
              :disabled="false"
              :open-on-click="true"
              :open-on-focus="true"
              :clear-on-select="true"
              :close-on-select="true"
              :always-open="false"
              :append-to-body="false"
              :options="suppliers"
              :limit="3"
              :max-height="400"
              :value="filteredSupplierIds"
              @input="updatefilteredSupplierIds"
              @close="filterClosed"
            />
          </div>
          <!--Search button-->
          <div class="grid-item-button">
            <button
              class="g-button button is-primary is-outlined is-rounded my-button"
              type="button"
              @click="commitSearchString"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
          <!-- Reset button -->
          <div class="grid-item-reset">
            <button
              class="g-reset button is-outlined is-danger is-rounded is-light"
              type="button"
              @click="resetSearch"
            >
              <i class="fa fa-eraser"> Reset pretrage</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
// import VueSelect from "vue-select";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "vue-select/dist/vue-select.css";
// import _ from "lodash";
import { mapActions, mapState, mapMutations } from "vuex";
// import Axios from "axios";
// Import category nester for rearange categories retrieved from web
// import nester from "../assets/js/categoryNester.js";

const STATUS_INITIAL = 0,
  STATUS_FILTER = 1;

export default {
  components: { Treeselect },
  data() {
    return {
      // selectedCategoryId: null,
      // selectedManufacturerIds: null,
      selectedSupplierIds: null,
      filterOptions: [
        "sortirano po cijeni opadajuće",
        "sortirano po cijeni rastuće",
      ],
      toggleStrictSearchValue: false,
      currentStatus: STATUS_INITIAL,
      searchPlaceholder: "Traži artikal...",
      categoryPlaceholder: "Traži po kategoriji...",
      manufacturerPlaceholder: "Traži po proizvođaču...",
      supplierPlaceholder: "Traži po distributeru...",
      // awaitingSearch: false,
    };
  },
  computed: {
    ...mapState([
      "categories",
      "manufacturers",
      "suppliers",
      "filteredManufacturerIds",
      "filteredSupplierIds",
      "selectedCategoryId",
    ]),
    rawString: {
      get() {
        return this.$store.state.rawString;
      },
      set(value) {
        this.$store.dispatch("setRawString", value);
      },
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isFilter() {
      return this.currentStatus === STATUS_FILTER;
    },
  },
  methods: {
    ...mapActions([
      "getCategories",
      "getManufacturers",
      "getSuppliers",
      "setSelectedCategoryId",
      "getPromoItems",
    ]),
    ...mapMutations([
      "updateFilteredManufacturerIds",
      "updatefilteredSupplierIds",
      "SET_SELECTEDCATEGORYID",
      "SET_RAWSTRING",
      "SET_SEARCH_STATUS",
      // "FILTER_MANUFACTURER_FACETS",
      // "FILTER_SUPPLIER_FACETS",
      "RESET_MANUFACTURERS",
      "RESET_SUPPLIERS",
      "SET_PROMO",
    ]),
    filterClosed() {
      if (
        this.filteredManufacturerIds.length ||
        this.filteredSupplierIds.length
      ) {
        this.SET_PROMO(false);
        this.commitSearchString();
      }
    },
    commitSearchString() {
      console.log("changed!");
      // _.debounce(() => {
      //   this.$store.dispatch("setSearchString");
      // }, 2000);
      this.$store.dispatch("setSearchString");
    },
    resetSearch() {
      this.SET_SELECTEDCATEGORYID(null);
      this.SET_RAWSTRING("");
      this.updateFilteredManufacturerIds([]);
      this.updatefilteredSupplierIds([]);
      this.RESET_MANUFACTURERS();
      this.RESET_SUPPLIERS();

      this.getPromoItems();
    },
    clearSearchInput() {
      this.$store.dispatch("setRawString", "");
      this.$refs.searchInput.focus();
    },
    toggleStrictSearch() {
      if (this.$store.state.rawString !== "") {
        console.log("toggle");
        console.log(this.$store.state.rawString);
        this.$store.commit(
          "SET_RAW_STRING_STRICT",
          this.toggleStrictSearchValue
        );
        this.toggleStrictSearchValue = !this.toggleStrictSearchValue;
      }

      this.$refs.searchInput.focus();
      // this.commitSearchString();
    },
    checkCurrentState() {
      // search status calculation
      // if(this.selectedCategoryId !== null){
      //   console.log("A");
      // }
      // if(this.$store.state.rawString !== ""){
      //   console.log("B");
      // }
      // if(!Array.isArray(this.$store.state.filteredManufacturerIds)){
      //   console.log("C");
      // }
      // if(this.$store.state.filteredManufacturerIds.length){
      //   console.log("D");
      // }
      if (
        this.selectedCategoryId !== null ||
        this.$store.state.rawString !== "" ||
        this.$store.state.filteredManufacturerIds.length ||
        this.$store.state.filteredSupplierIds.length
      ) {
        this.SET_SEARCH_STATUS("filter");
        // this.FILTER_MANUFACTURER_FACETS();
        this.currentStatus = STATUS_FILTER;
        this.searchPlaceholder = "Traži artikal...";
        this.categoryPlaceholder = "Filtriraj po kategoriji...";
        this.manufacturerPlaceholder = "Filtriraj po proizvođaču...";
        this.supplierPlaceholder = "Filtriraj po distributeru...";
        console.log("filter!");
        console.log(this.selectedCategoryId);
        console.log(this.$store.state.rawString);
        console.log(this.$store.state.filteredManufacturerIds);
        console.log(this.$store.state.filteredSupplierIds);
      } else {
        this.SET_SEARCH_STATUS("initial");
        this.currentStatus = STATUS_INITIAL;
        this.searchPlaceholder = "Traži artikal...";
        this.categoryPlaceholder = "Traži po kategoriji...";
        this.manufacturerPlaceholder = "Traži po proizvođaču...";
        this.supplierPlaceholder = "Traži po distributeru...";
        console.log("initial!");
        console.log(this.selectedCategoryId);
        console.log(this.$store.state.rawString);
        console.log(this.$store.state.filteredManufacturerIds);
        console.log(this.$store.state.filteredSupplierIds);
      }
    },
  },
  watch: {
    selectedCategoryId: function(newValue) {
      console.log(newValue);
      this.checkCurrentState();
      if (typeof newValue !== "undefined") {
        this.eventBus.$emit("getItemsByCategoryId", newValue);
      }
    },
    rawString: function() {
      this.checkCurrentState();
    },
  },
  created() {
    this.getCategories();
    this.getManufacturers();
    this.getSuppliers();
  },
  inject: ["eventBus"],
};
</script>

<style scoped>
.my-button {
  border: 1px 1px 1px 0px dotted cornflowerblue;
  border-radius: 0%;
}

.my-categories {
  background-color: #f2f2f2;
  border: 1px 1px 1px 0px dotted cornflowerblue;
  border-radius: 0%;
}

.my-categories >>> .vue-treeselect__control {
  background-color: #f2f2f2;
  border: 0px;
  border-style: none;
  border-color: crimson;
}

/* Dodao Koča pri ubacivanju "serach" dugmeta unutar polja */
/* Prazno polje radi commit testa */
.columns-test {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}

/* Grid system */
.grid-container {
  display: grid;
  align-items: stretch;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  grid-template-areas:
    "search search"
    "category category"
    "manufacturer manufacturer"
    "supplier supplier"
    "button reset";
  /* background-color: #2196f3; */
  padding: 2px;
}

.g-input {
  height: 100%;
  width: 100%;
  font-size: x-large;
}

.g-search-x {
  color: rgb(209, 209, 209);
  background: transparent;
  border: none !important;
  font-size: x-large;
}

.g-search-x:focus {
  outline: none;
}

.g-search-x:hover {
  color: rgb(218, 30, 30);
}

.g-button {
  height: 100%;
  font-size: x-large;
}

.g-reset {
  height: 60%;
  width: 70%;
  font-size: large;
}

.grid-item-search {
  background-color: rgba(255, 3, 255, 0.8);
  border: 0px solid rgba(0, 0, 0, 0.8);
  margin-top: 5px;
  text-align: center;
  grid-area: search;
}

.grid-item-search-x {
  margin-right: 10px;
  grid-area: search;
  justify-self: end;
  align-self: center;
}

.grid-item-search-strict {
  margin-right: 40px;
  grid-area: search;
  justify-self: end;
  align-self: center;
}

.grid-item-category {
  background-color: rgba(255, 3, 255, 0.8);
  border: 0px solid rgba(0, 0, 0, 0.8);
  margin-top: 5px;
  text-align: center;
  grid-area: category;
}

.grid-item-manufacturer {
  /* background-color: rgba(255, 3, 255, 0.8); */
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 10px;
  margin-bottom: 4px;
  border: 0px solid rgba(0, 0, 0, 0.8);
  text-align: center;
  grid-area: manufacturer;
}

.grid-item-supplier {
  /* background-color: rgba(255, 3, 255, 0.8); */
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 10px;
  margin-bottom: 4px;
  border: 0px solid rgba(0, 0, 0, 0.8);
  text-align: center;
  grid-area: supplier;
}

.grid-item-button {
  border: 0px solid rgba(0, 0, 0, 0.8);
  margin-left: 10px;
  margin-right: 0px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  grid-area: button;
  justify-self: end;
}

.grid-item-reset {
  border: 0px solid rgba(0, 0, 0, 0.8);
  text-align: center;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 10px;
  margin-bottom: 10px;
  grid-area: reset;
  justify-self: start;
  align-self: center;
}

/* Screen larger than 600px? 4 columns */
@media (min-width: 600px) {
  .grid-container {
    display: grid;
    align-items: stretch;
    grid-template-columns: 1fr 1fr 1fr 1fr auto;
    grid-template-rows: auto;
    grid-template-areas:
      "search search category category button"
      "manufacturer manufacturer supplier supplier button"
      ". reset reset . .";
    /* background-color: #2196f3; */
    padding: 2px;
  }

  .grid-item-manufacturer {
    /* background-color: rgba(255, 3, 255, 0.8); */
    margin-left: 20px;
    margin-right: 4px;
    margin-top: 10px;
    margin-bottom: 4px;
    border: 0px solid rgba(0, 0, 0, 0.8);
    text-align: center;
    grid-area: manufacturer;
  }

  .grid-item-supplier {
    /* background-color: rgba(255, 3, 255, 0.8); */
    margin-left: 4px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 4px;
    border: 0px solid rgba(0, 0, 0, 0.8);
    text-align: center;
    grid-area: supplier;
  }

  .grid-item-button {
    border: 0px solid rgba(0, 0, 0, 0.8);
    margin-left: 10px;
    margin-right: 2px;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    grid-area: button;
    justify-self: end;
  }

  .grid-item-reset {
    border: 0px solid rgba(0, 0, 0, 0.8);
    text-align: center;
    margin-left: 2px;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    grid-area: reset;
    justify-self: stretch;
    align-self: center;
  }

  .grid-item-search-x {
    margin-right: 10px;
    grid-area: search;
    justify-self: end;
    align-self: center;
  }

  .grid-item-search-strict {
    margin-right: 30px;
    grid-area: search;
    justify-self: end;
    align-self: center;
  }

  .g-search-x {
    color: rgb(209, 209, 209);
    background: transparent;
    border: none !important;
    font-size: small;
  }
}
</style>
